import axios from "axios";
import Globais, {
  validateToken,
  validaCPF,
  validacaoEmail,
  logout,
} from "../../components/Globais";

import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

//Import Material UI - Steps

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useQueryParams, StringParam, NumberParam } from "use-query-params";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Typography from "@mui/material/Typography";
import PhoneInput from "react-phone-input-2";

//Import Ant-Design
import {
  Card,
  Col,
  Divider,
  Flex,
  Form,
  Input,
  Row,
  message,
  Select,
  Skeleton,
  Typography as TypographyAntd,
} from "antd";

import MaskedInput from "antd-mask-input";
import { numberPadrao } from "../../uteis/formatPhoneNumber";

const CardTitle = styled.div`
  font-size: 24px;
  font-weight: bold;
  text-wrap: wrap;
  @media (min-width: 200px) and (max-width: 430px) {
    font-size: 1rem;
  }
  @media (min-width: 431px) and (max-width: 820px) {
    font-size: 1.8rem;
  }
  @media (min-width: 821px) and (max-width: 1025px) {
    font-size: 2.2rem;
  }
`;
const ContainerButton = styled.div`
  margin-top: -2%;
  @media (min-width: 200px) and (max-width: 430px) {
    margin-top: -10%;
  }
`;

const Seta = styled.img`
  width: 3rem;
  height: 3rem;

  cursor: pointer;
  margin-top: 1rem;
  margin-left: 1rem;
  @media (max-height: 650px), (max-width: 650px) {
    width: 2rem;
    height: 2rem;
    margin-top: 0.5rem;
  }
`;
const ContainerSeta = styled.div`
  width: 100%;
  height: 100%;

  grid-column-start: 1;
  grid-row-start: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default function ViewCadastroPropriedade() {
  interface Cadastro {
    usuarioId?: number;
    nome?: string;
    sobrenome?: string;
    email?: string;
    cpf?: string;
    rg?: string;
    celular?: string;
    nacionalidade?: string;
    paisId?: number;
    estadoCivil?: string;
    endereco?: string;
    complemento?: string;
    estadoId?: number;
    cidadeId?: number;
  }
  interface Pais {
    id: number;
    nome: string;
    abreviacao: string;
    origem: number;
  }

  interface EstadoCivil {
    id: number;
    label: string;
    value: string;
  }
  interface Estado {
    id: number;
    nome: string;
    abreviacao: string;
    origem: number;
  }

  interface Cidade {
    id: number;
    nome: string;
    estadoId: number;
  }

  //-----------------------------------------------------------------------------------------------------------\\
  const { Title } = TypographyAntd;
  const steps = ["Atualizar Cadastro", "Cadastrar Representante", "Concluído"];
  const [paises, setPaises] = useState<Pais[]>([]);
  const [selectedEstado, setSelectedEstado] = useState<number>();
  const [estados, setEstados] = useState<Estado[]>([]);
  const [cidades, setCidades] = useState<Cidade[]>([]);
  const isLoading = useRef(false);
  const [activeStep, setActiveStep] = useState(0);
  // UseState necessário para armazenamento dos dados do formulario de atualização de cadastro do usuário
  const [formAtualizarCadastro, setFormAtualizarCadastro] = useState<Cadastro>(
    {}
  );
  // UseState necessário para armazenamento de dados do formulario de cadastro de proprietario
  const [formCadastroRepresentante, setFormCadastroRepresentante] =
    useState<Cadastro>({});
  const layout = {
    //Layout que altera o tamanho e a posição dos nomes e labels dos formulários de : Empreendimentos,Especificações de Apto,Cadastrar Apartamento,AtualizarCadastro,CadastroProprietario
    labelCol: { span: 10 },
    wrapperCol: { span: 16 },
  };

  /* eslint-disable no-template-curly-in-string */ // Constante que válida os campos de todos os  formulário
  const validarFormulario = {
    required: "${label} é necessário!",
    types: {
      email: "${label} não é válido!",
      number: "${label} não é um número!",
    },
  };
  /* eslint-enable no-template-curly-in-string */
  const estadoCivilOpcoes = [
    //Array de Opções usadas no SELECT de atualizar cadastro e cadastrar proprietario
    { id: 1, label: "Solteiro", value: "SOLTEIRO" },
    { id: 2, label: "Casado", value: "CASADO" },
    { id: 3, label: "Separado", value: "SEPARADO" },
    { id: 4, label: "Divorciado", value: "DIVORCIADO" },
    { id: 5, label: "Viúvo", value: "VIUVO" },
  ];
  const estadoCivil: EstadoCivil[] = estadoCivilOpcoes.map((ec) => ({
    // Map do array
    id: ec.id,
    label: ec.label,
    value: ec.value,
  }));

  const [cotaUsuarioId, setCotaUsuarioId] = useQueryParams({
    cotaUsuarioId: NumberParam,
  });

  const [bloquearBotaoProximo, setBloquearBotaoProximo] = useState(true);
  const [atualizarCadastroRepresentante] = Form.useForm();
  const [atualizarCadastroProprietario] = Form.useForm();

  const [messageApi, contextHolder] = message.useMessage();

  const showError = (message: string) => {
    messageApi.open({
      type: "error",
      content: message,
    });
  };

  const changing = useRef<boolean>(false);
  //-----------------------------------------------------------------------------------------------------------\\

  // UseEffect necessário para buscar os Paises
  useEffect(() => {
    const fetchToken = async () => {
      const Token = validateToken();

      if (Token) {
        const URL = `${Globais.DOMINIOBACK}/pais`;

        try {
          const response = await axios.get(URL, {
            headers: { Authorization: Token.AuthStr },
          });
          if (response) {
            const paises: Pais[] = response.data;

            // Filtrando os paises com origem igual a 0
            const paisesComOrigemZero = paises.filter(
              (pais: Pais) => pais.origem === 0
            );

            setPaises(paisesComOrigemZero);
          }
        } catch (error) {
          if (error.response.status === 401) {
            logout();
            console.log(error);
          } else {
            console.error("Erro ao buscar paises:", error);
          }
        }
      }
    };
    fetchToken();
  }, []);
  // UseEffect necessário para Buscar Estado
  useEffect(() => {
    const fetchToken = async () => {
      const Token = validateToken();

      if (Token) {
        const URL = `${Globais.DOMINIOBACK}/estado`;

        try {
          const response = await axios.get(URL, {
            headers: { Authorization: Token.AuthStr },
          });
          if (response) {
            const estados: Estado[] = response.data;

            // Filtrando os estados com origem igual a 0
            const estadosComOrigemZero = estados.filter(
              (estado: Estado) => estado.origem === 0
            );

            setEstados(estadosComOrigemZero);
          }
        } catch (error) {
          if (error.response.status === 401) {
            logout();
            console.log(error);
          } else {
            console.error("Erro ao buscar estados:", error);
          }
        }
      }
    };
    fetchToken();
  }, []);

  //Buscar Cidade de acordo com o Estado selecionado
  useEffect(() => {
    if (selectedEstado) {
      const fetchToken = async () => {
        const Token = validateToken();

        if (Token) {
          const URL = `${Globais.DOMINIOBACK}/cidade`;
          try {
            const response = await axios.get(URL, {
              headers: { Authorization: Token.AuthStr },
            });
            if (response) {
              const cidades: Cidade[] = response.data;
              // Filtrando as cidades selecionadas
              const cidade = cidades.filter(
                (cidade: Cidade) => cidade.estadoId === selectedEstado
              );

              setCidades(cidade);
            }
          } catch (error) {
            if (error.response.status === 401) {
              logout();
              console.log(error);
            } else {
              console.error("Erro ao buscar cidades:", error);
            }
          }
        }
      };
      fetchToken();
    }
  }, [selectedEstado]);

  //-----------------------------------------------------------------------------------------------------------\\

  const cadastrarRepresentanteChange = (
    changedValues: Partial<Cadastro>,
    allValues: Cadastro
  ) => {
    changing.current = true;
    setFormCadastroRepresentante((prevState) => ({
      ...prevState,
      ...allValues,
    }));
    let cpfDigitado =
      changedValues.cpf !== undefined
        ? changedValues.cpf?.indexOf("_")
        : formCadastroRepresentante.cpf?.indexOf("_");
    let celularDigitado =
      changedValues.celular !== undefined
        ? changedValues.celular?.indexOf("_")
        : formCadastroRepresentante.celular?.indexOf("_");

    if (
      changedValues.nome === "" ||
      changedValues.sobrenome === "" ||
      cpfDigitado !== -1 ||
      changedValues.rg === "" ||
      changedValues.email === "" ||
      celularDigitado !== -1 ||
      changedValues.endereco === "" ||
      changedValues.complemento === ""
    ) {
      setBloquearBotaoProximo(true);
    }

    //validação preenchimento de todos os campos. Se as condições forem atendidas o botão proximo será liberado
    if (
      (formCadastroRepresentante.nome === "" &&
        changedValues.nome !== "" &&
        !(
          (formCadastroRepresentante.nome !== "" &&
            changedValues.nome === "") ||
          changedValues.nome === undefined
        )) ||
      (formCadastroRepresentante.nome !== "" && changedValues.nome !== "")
    ) {
      if (
        (!(
          formCadastroRepresentante.sobrenome === undefined &&
          changedValues.sobrenome === undefined
        ) &&
          !(
            formCadastroRepresentante.sobrenome !== undefined &&
            changedValues.sobrenome === ""
          )) ||
        (formCadastroRepresentante.sobrenome !== undefined &&
          changedValues.sobrenome !== undefined &&
          changedValues.sobrenome !== "")
      ) {
        if (cpfDigitado === -1) {
          if (
            (!(
              formCadastroRepresentante.email === undefined &&
              changedValues.email === undefined
            ) &&
              !(
                formCadastroRepresentante.email !== undefined &&
                changedValues.email === ""
              )) ||
            (formCadastroRepresentante.email !== undefined &&
              changedValues.email !== undefined &&
              changedValues.email !== "")
          ) {
            if (allValues.rg !== undefined && allValues.rg !== "") {
              if (celularDigitado === -1) {
                if (
                  !(
                    formCadastroRepresentante.nacionalidade === undefined &&
                    changedValues.nacionalidade === undefined
                  ) &&
                  (formCadastroRepresentante.nacionalidade !== undefined ||
                    changedValues.nacionalidade !== undefined)
                ) {
                  if (
                    !(
                      formCadastroRepresentante.estadoCivil === undefined &&
                      changedValues.estadoCivil === undefined
                    ) &&
                    (formCadastroRepresentante.estadoCivil !== undefined ||
                      changedValues.estadoCivil !== undefined)
                  ) {
                    if (
                      (!(formCadastroRepresentante.endereco === "") &&
                        !(
                          formCadastroRepresentante.endereco === undefined &&
                          changedValues.endereco === undefined
                        ) &&
                        !(
                          formCadastroRepresentante.endereco !== undefined &&
                          changedValues.endereco === ""
                        )) ||
                      (formCadastroRepresentante.endereco !== undefined &&
                        changedValues.endereco !== undefined &&
                        changedValues.endereco !== "")
                    ) {
                      if (
                        (!(formCadastroRepresentante.complemento === "") &&
                          !(
                            formCadastroRepresentante.complemento ===
                              undefined &&
                            changedValues.complemento === undefined
                          ) &&
                          !(
                            formCadastroRepresentante.complemento !==
                              undefined && changedValues.complemento === ""
                          )) ||
                        (formCadastroRepresentante.complemento !== undefined &&
                          changedValues.complemento !== undefined &&
                          changedValues.complemento !== "")
                      ) {
                        if (
                          !(
                            formCadastroRepresentante.estadoId === undefined &&
                            changedValues.estadoId === undefined
                          ) &&
                          (formCadastroRepresentante.estadoId !== undefined ||
                            changedValues.estadoId !== undefined)
                        ) {
                          if (
                            !(
                              formCadastroRepresentante.cidadeId ===
                                undefined &&
                              changedValues.cidadeId === undefined
                            ) &&
                            (formCadastroRepresentante.cidadeId !== undefined ||
                              changedValues.cidadeId !== undefined)
                          ) {
                            setBloquearBotaoProximo(false);
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  };

  const atualizarCadastroChange = (
    changedValues: Partial<Cadastro>,
    allValues: Cadastro
  ) => {
    changing.current = true;

    setFormAtualizarCadastro((prevState) => ({
      ...prevState,
      ...allValues,
    }));

    // caso os campos endereço e complemento sejam apagados o botão proximo fica desabilitado

    if (
      changedValues.endereco === "" ||
      changedValues.complemento === "" ||
      changedValues.rg === ""
    ) {
      setBloquearBotaoProximo(true);
    }

    // só habilita o botão proximo após validar
    if (allValues.rg !== "") {
      if (
        allValues.nacionalidade !== undefined &&
        allValues.nacionalidade !== ""
      ) {
        if (
          allValues.estadoCivil !== undefined &&
          allValues.estadoCivil !== ""
        ) {
          if (allValues.endereco !== undefined && allValues.endereco !== "") {
            if (
              allValues.complemento !== undefined &&
              allValues.complemento !== ""
            ) {
              if (allValues.estadoId !== undefined) {
                if (allValues.cidadeId !== undefined) {
                  console.log("desbloqueando");
                  setBloquearBotaoProximo(false);
                }
              }
            }
          }
        }
      }
    }
  };

  // Função que armazena o id do pais selecionado para a atualização de cadastro e cadastro do proprietario
  const paisChange = (value: any) => {
    // Encontrar o país correspondente ao valor selecionado
    const paisSelecionado = paises.find((pais) => pais.abreviacao === value);

    // Verificar se encontrou o país
    if (paisSelecionado) {
      setFormAtualizarCadastro((prevState) => ({
        ...prevState,
        paisId: paisSelecionado.id,
      }));
      setFormCadastroRepresentante((prevState) => ({
        ...prevState,
        paisId: paisSelecionado.id,
      }));
    }
  };

  const handleEstadoChange = (value: number, form: any) => {
    setSelectedEstado(value);
    form.setFieldsValue({ cidadeId: undefined });
    setCidades([]); // Limpa as cidades quando o estado muda
  };
  const error = (texto: string) => {
    messageApi.open({
      type: "error",
      content: texto,
    });
  };

  const [completedSteps, setCompletedSteps] = useState([false, false, false]);

  // Função chamada ao concluir um passo
  const completeStep = (step: number) => {
    setCompletedSteps((prevSteps) => {
      const updatedSteps = [...prevSteps];
      updatedSteps[step] = true;
      return updatedSteps;
    });
  };
  const handleStepClick = (index: any) => {
    switch (index) {
      case 0:
        if (activeStep !== 0) {
          setActiveStep(index);
        } else {
          error(
            "Por favor, conclua o preenchimento dos dados para prosseguir."
          );
        }
        break;
      case 1:
        if (!completedSteps[0]) {
          console.log(completedSteps[0]);
          // Verifica se o passo 0 foi concluído
          error("Complete os dados para avançar ao cadastro do representante.");
        } else {
          setActiveStep(index);
        }
        break;
      case 2:
        if (!completedSteps[0]) {
          error("Conclua o preenchimento dos dados antes de prosseguir.");
        } else if (!completedSteps[1]) {
          error("Finalize o cadastro do representante antes de prosseguir.");
        } else {
          setActiveStep(index);
        }
        break;
      default:
        error("Passo inválido.");
    }
  };

  const handleNext = async () => {
    switch (activeStep) {
      case 0:
        if (changing.current) {
          const atualizandoDados = await atualizarDados();
          if (atualizandoDados) {
            completeStep(activeStep);
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            setBloquearBotaoProximo(true);
          } else {
            console.error("Não foi possível prosseguir, tente novamente");
          }
        } else {
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
          setBloquearBotaoProximo(false);
        }

        break;
      case 1:
        if (changing.current) {
          const representantes = await representante();
          if (representantes) {
            completeStep(activeStep);
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
          } else {
            console.log("Não foi foi possível prosseguir, tente novamente");
          }
        } else {
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
          setBloquearBotaoProximo(false);
        }

        break;
      case 2:
        document.location.href = `/cadastroCotas`;

        break;

      default:
        break;
    }
  };

  // Função principal que volta a etapa do componente STEPS
  const handleBack = () => {
    setBloquearBotaoProximo(false);
    changing.current = false;

    if (activeStep > 0) {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    } else {
      // Se não houver renderizações anteriores, volte para o início do step
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  const [phone, setPhone] = useState("");
  const handlePhoneChange = (value: string) => {
    setPhone(numberPadrao(value));
    console.log(numberPadrao(value));
  };

  const buscarEndereco = async (idUsuario?: number): Promise<boolean> => {
    const Token = validateToken();

    if (Token) {
      const usuarioId = idUsuario ? idUsuario : Token.id;
      const URL = `${Globais.DOMINIOBACK}/endereco/usuario/${usuarioId}`;
      try {
        const response = await axios.get(URL, {
          headers: { Authorization: Token.AuthStr },
        });

        if (response.data && Object.keys(response.data).length > 0) {
          const sucesso = await atualizarEndereco(response.data.id);
          if (sucesso) {
            return true;
          } else {
            return false;
          }
        } else {
          let sucesso;
          if (usuarioId !== Token.id) {
            // se UsuarioId for diferente do que está logado, caminho cadastro representante
            sucesso = await cadastrarEndereco(usuarioId);
          } else {
            // se UsuarioId for igual, caminho atualizarCadastro
            sucesso = await cadastrarEndereco();
          }

          if (sucesso) {
            return true;
          } else {
            return false;
          }
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    } else {
      return false;
    }
  };
  // Função de cadastro de endereço
  const cadastrarEndereco = async (usuarioId?: number): Promise<boolean> => {
    const Token = validateToken();
    if (Token) {
      const tokenId = usuarioId ? usuarioId : Token.id;
      const URL = `${Globais.DOMINIOBACK}/endereco`;
      const form = usuarioId
        ? formCadastroRepresentante
        : formAtualizarCadastro;
      const values = {
        usuarioId: tokenId,
        endereco: form.endereco,
        complemento: form.complemento,
        cidadeId: form.cidadeId,
        estadoId: form.estadoId,
        paisId: form.paisId,
      };

      try {
        const response = await axios.post(URL, values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });

        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    } else {
      return false;
    }
  };

  const atualizarEndereco = async (
    enderecoId: number,
    usuarioId?: number
  ): Promise<boolean> => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/endereco`;
      const form = usuarioId
        ? formCadastroRepresentante
        : formAtualizarCadastro;
      const values = {
        endereco: form.endereco,
        complemento: form.complemento,
        cidadeId: form.cidadeId,
        estadoId: form.estadoId,
        paisId: form.paisId,
        enderecoId: enderecoId,
      };

      try {
        const response = await axios.put(URL, values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });

        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    } else {
      return false;
    }
  };
  // Função principal que é chamada em handleNext para a atualização de cadastro
  const atualizarDados = async (): Promise<boolean> => {
    const sucesso = await atualizarUsuario();
    if (sucesso) {
      const sucesso = await buscarEndereco();
      if (sucesso) {
        return true;
      } else {
        return false;
      }
    } else {
      alert(
        "Não foi possivel atualizar o cadastro, por favor tente novamente!"
      );
      return false;
    }
  };
  // Função de atualização de cadastro
  const atualizarUsuario = async (): Promise<boolean> => {
    const Token = validateToken();

    if (Token) {
      const tokenId = Token.id;
      const URL = `${Globais.DOMINIOBACK}/usuario/${tokenId}`;
      const values = {
        estadoCivil: formAtualizarCadastro.estadoCivil,
        nacionalidade: formAtualizarCadastro.nacionalidade,
        rg: formAtualizarCadastro.rg,
      };

      try {
        const response = await axios.put(URL, values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });

        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    } else {
      return false;
    }
  };

  const representante = async (): Promise<boolean> => {
    //Verificar se já existe usuario criado
    const usuario = await buscarUsuario();
    switch (usuario.resultado) {
      case 0:
        // não foi encontrado usuario. Criar outro usuario
        const sucessoCadastroUsuario = await cadastrarUsuario();
        if (sucessoCadastroUsuario) {
          return true;
        } else {
          return false;
        }

      case 1:
        //  foi encontrado usuario. Apenas vincula ele como representante
        const sucessoCadastroRepresentante = await cadastroRepresentante(
          usuario.id,
          "UsuarioExistente"
        );
        if (sucessoCadastroRepresentante) {
          return true;
        } else {
          return false;
        }

      case 2:
        showError("Já existe uma conta com esse e-mail, favor utilizar outro.");
        return false;

      // não foi encontrado usuario com mesmo CPF, mas o e-mail informado já está sendo usado por outro usuario. Avisar ao usuario cadastrante.
      case 3:
        showError(
          "O CPF incluido no formulário é o mesmo que você cadastrou como seu CPF. Inclua o CPF do proprietário"
        );
        return false;

      default:
        showError("Há algo de errado. Código de erro: VCP-045");
        return false;
    }
  };
  const cadastrarUsuario = async (): Promise<boolean> => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/usuario/0/0`;
      const values = {
        nome: formCadastroRepresentante.nome,
        sobrenome: formCadastroRepresentante.sobrenome,
        email: formCadastroRepresentante.email,
        cpf: formCadastroRepresentante.cpf,
        celular: numberPadrao(formCadastroRepresentante.celular),
        estadoCivil: formCadastroRepresentante.estadoCivil,
        nacionalidade: formCadastroRepresentante.nacionalidade,
        rg: formCadastroRepresentante.rg,
      };

      if (values.cpf && validaCPF(values.cpf)) {
        if (values.email && validacaoEmail(values.email)) {
          try {
            const response = await axios.post(URL, values, {
              headers: {
                "Content-Type": "application/json",
                Authorization: Token.AuthStr,
              },
            });
            const success = await cadastrarEndereco(response.data.id);
            if (success) {
              cadastroRepresentante(response.data.id);

              return true;
            } else {
              return false;
            }
          } catch (error) {
            return false;
          }
        } else {
          showError("E-mail inválido");
          return false;
        }
      } else {
        showError("CPF inválido");
        return false;
      }
    } else {
      return false;
    }
  };

  const buscarUsuario = async () => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/usuario/buscarUsuario`;
      const values = {
        usuarioLogadoId: Token.id,
        email: formCadastroRepresentante.email,
        cpf: formCadastroRepresentante.cpf,
      };
      try {
        const response = await axios.post(URL, values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });

        if (response) {
          return response.data;
        } else {
          showError("Há algo de errado. Código de erro: VCP-036");
          return false;
        }
      } catch (error) {
        throw error;
      }
    } else {
      return false;
    }
  };

  const cadastroRepresentante = async (
    usuarioId: number,
    usuarioExistente?: string
  ): Promise<boolean> => {
    const Token = validateToken();
    const usuario = usuarioExistente || undefined;
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/representante`;
      const values = {
        usuarioId: usuarioId,
        cotaUsuarioId: cotaUsuarioId.cotaUsuarioId,
      };

      try {
        const response = await axios.post(URL, values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });
        // Se usuário ja existe, ele irá cadastrar o Endereço
        if (usuario) {
          buscarEndereco(response.data.usuarioId);
        }

        return true;
      } catch (error) {
        console.log(error);

        return false;
      }
    } else {
      return false;
    }
  };

  const atualizarCadastro = (
    <>
      <Card
        title={<CardTitle> Favor atualizar seu cadastro:</CardTitle>}
        bordered={true}
        type="inner"
        className="mobile"
      >
        <Form
          form={atualizarCadastroProprietario}
          {...layout}
          name="atualizar-cadastro"
          onValuesChange={(changedValues, allValues) =>
            atualizarCadastroChange(changedValues, allValues)
          }
          initialValues={formAtualizarCadastro}
          style={{
            marginLeft: "25px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
          validateMessages={validarFormulario}
        >
          <Form.Item
            name={["nacionalidade"]}
            label="Nacionalidade"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Select
              onChange={paisChange}
              placeholder="Selecione a nacionalidade"
            >
              {paises.map((pais) => (
                <Select.Option key={pais.id} value={pais.abreviacao}>
                  {pais.nome}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name={["estadoCivil"]}
            label="Estado Civil"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Select placeholder="Selecione seu estado civil">
              {estadoCivil.map((ec, index) => (
                <Select.Option key={ec.id} value={ec.value}>
                  {ec.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name={["rg"]}
            label="RG"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Input placeholder="Digite seu RG" />
          </Form.Item>
          <Form.Item
            name={["endereco"]}
            label="Endereço"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={["complemento"]}
            label="Complemento"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Input />
          </Form.Item>

          <Form.Item
            name={["estadoId"]}
            label="Estado"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Select
              showSearch
              placeholder="Selecione o estado"
              onChange={(value) =>
                handleEstadoChange(value, atualizarCadastroProprietario)
              }
              filterOption={(input, option) => {
                if (typeof option?.label === "string") {
                  const inputLowerCase = input.toLowerCase();
                  const labelLowerCase = option.label.toLowerCase();
                  return (
                    labelLowerCase.includes(inputLowerCase) ||
                    option.label.includes(input) || // original input
                    option.label
                      .toLowerCase()
                      .includes(
                        inputLowerCase.charAt(0).toUpperCase() +
                          inputLowerCase.slice(1)
                      )
                  );
                }
                return false;
              }}
              filterSort={(optionA, optionB) => {
                if (
                  typeof optionA?.label === "string" &&
                  typeof optionB?.label === "string"
                ) {
                  return optionA.label
                    .toLowerCase()
                    .localeCompare(optionB.label.toLowerCase());
                }
                return 0;
              }}
            >
              {estados.map((estado) => (
                <Select.Option
                  key={estado.id}
                  value={estado.id}
                  label={estado.nome}
                >
                  {estado.nome}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name={["cidadeId"]}
            label="Cidade"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Select
              showSearch
              placeholder="Selecione a cidade"
              optionFilterProp="children"
              filterOption={(input, option) => {
                if (typeof option?.label === "string") {
                  const inputLowerCase = input.toLowerCase();
                  const labelLowerCase = option.label.toLowerCase();
                  return (
                    labelLowerCase.includes(inputLowerCase) ||
                    option.label.includes(input) || // original input
                    option.label
                      .toLowerCase()
                      .includes(
                        inputLowerCase.charAt(0).toUpperCase() +
                          inputLowerCase.slice(1)
                      )
                  );
                }
                return false;
              }}
              filterSort={(optionA, optionB) => {
                if (
                  typeof optionA?.label === "string" &&
                  typeof optionB?.label === "string"
                ) {
                  return optionA.label
                    .toLowerCase()
                    .localeCompare(optionB.label.toLowerCase());
                }
                return 0;
              }}
            >
              {cidades.map((cidade) => (
                <Select.Option
                  key={cidade.id}
                  value={cidade.id}
                  label={cidade.nome}
                >
                  {cidade.nome}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Card>
    </>
  );
  const cadastrarRepresentante = (
    <>
      <Card
        title={<CardTitle> Favor informar dados do representante:</CardTitle>}
        bordered={true}
        type="inner"
        className="mobile"
      >
        <Form
          form={atualizarCadastroRepresentante}
          {...layout}
          name="dados-proprietario"
          onValuesChange={(changedValues, allValues) =>
            cadastrarRepresentanteChange(changedValues, allValues)
          }
          initialValues={formCadastroRepresentante}
          style={{
            marginLeft: "25px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
          validateMessages={validarFormulario}
        >
          <Form.Item
            name={["nome"]}
            label="Nome"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={["sobrenome"]}
            label="Sobrenome"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={["cpf"]}
            label="CPF"
            rules={[{ required: true }]}
            className="formItems"
          >
            <MaskedInput mask="000.000.000-00" />
          </Form.Item>
          <Form.Item
            name={["rg"]}
            label="RG"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Input placeholder="Digite seu RG" />
          </Form.Item>
          <Form.Item
            name={["email"]}
            label="E-mail"
            rules={[{ type: "email" }]}
            className="formItems"
            required
          >
            <Input />
          </Form.Item>
          <Form.Item name={["celular"]} label="Celular" className="formItems">
            <PhoneInput
              country={"br"}
              value={phone}
              onChange={handlePhoneChange}
              placeholder="Digite seu telefone"
              inputClass="phone-input"
            />
          </Form.Item>
          <Form.Item
            name={["nacionalidade"]}
            label="Nacionalidade"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Select
              onChange={paisChange}
              placeholder="Selecione a nacionalidade"
            >
              {paises.map((pais) => (
                <Select.Option key={pais.id} value={pais.abreviacao}>
                  {pais.nome}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name={["estadoCivil"]}
            label="Estado Civil"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Select>
              {estadoCivil.map((ec, index) => (
                <Select.Option key={ec.id} value={ec.value}>
                  {ec.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name={["endereco"]}
            label="Endereço"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={["complemento"]}
            label="Complemento"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Input />
          </Form.Item>

          <Form.Item
            name={["estadoId"]}
            label="Estado"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Select
              showSearch
              placeholder="Selecione o estado"
              onChange={(value) =>
                handleEstadoChange(value, atualizarCadastroRepresentante)
              }
              filterOption={(input, option) => {
                if (typeof option?.label === "string") {
                  const inputLowerCase = input.toLowerCase();
                  const labelLowerCase = option.label.toLowerCase();
                  return (
                    labelLowerCase.includes(inputLowerCase) ||
                    option.label.includes(input) || // original input
                    option.label
                      .toLowerCase()
                      .includes(
                        inputLowerCase.charAt(0).toUpperCase() +
                          inputLowerCase.slice(1)
                      )
                  );
                }
                return false;
              }}
              filterSort={(optionA, optionB) => {
                if (
                  typeof optionA?.label === "string" &&
                  typeof optionB?.label === "string"
                ) {
                  return optionA.label
                    .toLowerCase()
                    .localeCompare(optionB.label.toLowerCase());
                }
                return 0;
              }}
            >
              {estados.map((estado) => (
                <Select.Option
                  key={estado.id}
                  value={estado.id}
                  label={estado.nome}
                >
                  {estado.nome}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name={["cidadeId"]}
            label="Cidade"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Select
              showSearch
              placeholder="Selecione a cidade"
              optionFilterProp="children"
              filterOption={(input, option) => {
                if (typeof option?.label === "string") {
                  const inputLowerCase = input.toLowerCase();
                  const labelLowerCase = option.label.toLowerCase();
                  return (
                    labelLowerCase.includes(inputLowerCase) ||
                    option.label.includes(input) || // original input
                    option.label
                      .toLowerCase()
                      .includes(
                        inputLowerCase.charAt(0).toUpperCase() +
                          inputLowerCase.slice(1)
                      )
                  );
                }
                return false;
              }}
              filterSort={(optionA, optionB) => {
                if (
                  typeof optionA?.label === "string" &&
                  typeof optionB?.label === "string"
                ) {
                  return optionA.label
                    .toLowerCase()
                    .localeCompare(optionB.label.toLowerCase());
                }
                return 0;
              }}
            >
              {cidades.map((cidade) => (
                <Select.Option
                  key={cidade.id}
                  value={cidade.id}
                  label={cidade.nome}
                >
                  {cidade.nome}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Card>
    </>
  );

  const cadastroConcluido = (
    <>
      <Card
        title={<CardTitle> Multicotas</CardTitle>}
        bordered={true}
        type="inner"
        className="mobile"
      >
        <div>
          <h3>Parabéns! Representante cadastrado com sucesso</h3>
        </div>
      </Card>
    </>
  );

  return (
    <>
      <Flex
        gap="middle"
        vertical
        align="center"
        justify="center"
        className="mobile"
      >
        {isLoading.current ? (
          <Skeleton active />
        ) : (
          <>
            {contextHolder}
            <Row
              style={{
                flex: "display",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <Col span={3}>
                <ContainerSeta>
                  <a href={`/cadastroCotas`}>
                    <ArrowBackIcon color="primary" />
                  </a>
                </ContainerSeta>
              </Col>
              <Col span={18}>
                <Title>Cadastro de Representante</Title>
              </Col>
              <Col span={3}></Col>
            </Row>

            <Divider />

            <Row>
              <Flex gap="large" vertical align="center" justify="center">
                <Stepper activeStep={activeStep}>
                  {/* Tem como função mapear os passos do array steps */}
                  {steps.map((label, index) => {
                    /* Cria o componente para cada step do array*/
                    return (
                      <Step key={label}>
                        <StepLabel onClick={() => handleStepClick(index)}>
                          {label}
                        </StepLabel>
                      </Step>
                    );
                  })}
                </Stepper>
                {/* Condicional de renderização */}

                {/* Renderiza condicionalmente o conteúdo dos passos (primeiroPasso, segundoPasso, terceiroPasso, quartoPasso) baseado no estado activeStep e isLoading.*/}
                <>
                  <Typography
                    component="div"
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {/* Renderização do Passo 1 */}
                    {activeStep === 0 && !isLoading.current && (
                      <>{atualizarCadastro}</>
                    )}
                    {activeStep === 1 && !isLoading.current && (
                      <>{cadastrarRepresentante}</>
                    )}
                    {activeStep === 2 && !isLoading.current && (
                      <>{cadastroConcluido}</>
                    )}
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      pt: 2,
                      marginBottom: 10,
                    }}
                  >
                    <ContainerButton>
                      <Button
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        sx={{ mr: 1 }}
                      >
                        Voltar
                      </Button>
                    </ContainerButton>
                    <Box sx={{ flex: "1 1 auto" }} />

                    <ContainerButton>
                      <Button
                        disabled={bloquearBotaoProximo}
                        onClick={handleNext}
                      >
                        {activeStep === steps.length - 1
                          ? "Finalizar"
                          : "Próximo"}
                      </Button>
                    </ContainerButton>
                  </Box>
                </>
              </Flex>
            </Row>
          </>
        )}
      </Flex>
    </>
  );
}
